import { render, staticRenderFns } from "./multi-choice.vue?vue&type=template&id=522509c2&scoped=true&"
import script from "./multi-choice.vue?vue&type=script&lang=js&"
export * from "./multi-choice.vue?vue&type=script&lang=js&"
import style0 from "./multi-choice.vue?vue&type=style&index=0&id=522509c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522509c2",
  null
  
)

component.options.__file = "multi-choice.vue"
export default component.exports